import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });
const apiV2 = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL_V2 });
const dialogApi = axios.create({ baseURL: process.env.REACT_APP_DIALOG_URL });
const billing = axios.create({ baseURL: process.env.REACT_APP_BILLING_API_URL });
const atomicHub = axios.create({ baseURL: process.env.REACT_APP_ATOMIC_PRODUCT_HUB_SERVER_URL });

[api, apiV2, billing, dialogApi, atomicHub].forEach((instance) => {
	instance.interceptors.request.use(async (config) => {
		return config;
	});
});

export { api, apiV2, billing, dialogApi, atomicHub };
